var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkleSvgPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 l -7.432 -25.158 c -0.352 -0.92 -0.77 -1.823 -1.246 -2.687 c -0.486 -0.884 -1.04 -1.741 -1.647 -2.55 c -0.607 -0.807 -1.276 -1.578 -1.989 -2.291 c -0.715 -0.714 -1.486 -1.384 -2.292 -1.99 c -0.804 -0.605 -1.662 -1.158 -2.548 -1.646 c -0.862 -0.474 -1.765 -0.893 -2.688 -1.246 L 0 45 l 25.158 -7.432 c 0.918 -0.351 1.822 -0.77 2.687 -1.246 c 0.885 -0.487 1.743 -1.041 2.549 -1.647 c 0.807 -0.607 1.579 -1.276 2.293 -1.99 c 0.712 -0.713 1.382 -1.485 1.989 -2.292 c 0.605 -0.806 1.159 -1.664 1.647 -2.549 c 0.475 -0.865 0.894 -1.769 1.245 -2.687 L 45 0 l 7.432 25.157 c 0.353 0.923 0.771 1.826 1.246 2.686 c 0.489 0.888 1.042 1.746 1.646 2.55 c 0.606 0.806 1.276 1.578 1.991 2.294 c 0.712 0.711 1.483 1.381 2.292 1.989 c 0.808 0.606 1.665 1.16 2.548 1.646 c 0.864 0.475 1.767 0.894 2.687 1.246 L 90 45 l -25.157 7.432 c -0.925 0.353 -1.828 0.772 -2.686 1.245 c -0.887 0.488 -1.745 1.042 -2.551 1.648 c -0.806 0.605 -1.577 1.275 -2.293 1.99 c -0.713 0.714 -1.383 1.485 -1.989 2.292 c -0.606 0.806 -1.16 1.663 -1.645 2.548 c -0.475 0.86 -0.894 1.763 -1.247 2.688 L 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      fill: "#E879F9"
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleSvgPink);
export default __webpack_public_path__ + "static/media/sparkleSvgPink.83c4a38e620ac5e951077868ac1a220d.svg";
export { ForwardRef as ReactComponent };